import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "toast-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "toast-icon" }
const _hoisted_4 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_6 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_7 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_8 = { class: "toast-content" }
const _hoisted_9 = { class: "toast-title" }
const _hoisted_10 = { class: "toast-body" }
const _hoisted_11 = {
  key: 0,
  class: "toast-meta"
}
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "toast-slide" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
            return (_openBlock(), _createElementBlock("div", {
              key: notification.id,
              class: _normalizeClass(['toast', `toast-${notification.type}`]),
              onClick: ($event: any) => (_ctx.handleClick(notification))
            }, [
              _createElementVNode("div", _hoisted_3, [
                (notification.type === 'success')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }, null, -1)
                    ]))]))
                  : (notification.type === 'error')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }, null, -1)
                      ]))]))
                    : (notification.type === 'warning')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("path", { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" }, null, -1)
                        ]))]))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(notification.title), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(notification.body), 1),
                (notification.deviceName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 📍 " + _toDisplayString(notification.deviceName), 1))
                  : _createCommentVNode("", true)
              ]),
              (notification.dismissible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "toast-close",
                    onClick: _withModifiers(($event: any) => (_ctx.dismiss(notification.id)), ["stop"]),
                    "aria-label": "Close"
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
                    ], -1)
                  ]))], 8, _hoisted_12))
                : _createCommentVNode("", true),
              (notification.duration && notification.duration > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "toast-progress",
                    style: _normalizeStyle({ animationDuration: `${notification.duration}ms` })
                  }, null, 4))
                : _createCommentVNode("", true)
            ], 10, _hoisted_2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}